import { SaveRounded as SaveRoundedIcon } from '@mui/icons-material'
import {
  Box,
  Button,
  Checkbox,
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext'
import ZDialog from '../../Shared/Dialogs/ZDialog'
import { useRoles } from '../Contexts/RolesContext'

const RolesDialog = ({ isOpen, setIsOpen = () => { } }) => {
  const { openErrorAlert, openSuccessAlert } = useGlobalContext()
  const { useCreateRoleStandardQuery } = useRoles()


  const [payload, setPayload] = useState({
    name: '',
    permissions: {
      devices: { c: false, r: false, u: false, d: false },
      downlinks: { c: false, r: false, u: false, d: false },
      automations: { c: false, r: false, u: false, d: false },
      network: { c: false, r: false, u: false, d: false },
      gateways: { c: false, r: false, u: false, d: false },
      organizations: { c: false, r: false, u: false, d: false },
      roles: { c: false, r: false, u: false, d: false },
      users: { c: false, r: false, u: false, d: false },
      system: { c: false, r: false, u: false, d: false }
    }
  })

  const entities = Object.keys(payload.permissions).sort() || []

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSaveRole = () => {
    useCreateRoleStandardQuery(payload)
      .then(() => {
        openSuccessAlert()
        setIsOpen(false)
      })
      .catch((err) => openErrorAlert({ keys: err.data.keys }))
  }

  const handleNameChanged = (event) =>
    setPayload({
      ...payload,
      name: event.target.value
    })

  const handleChange = (entity, action, value) => {
    setPayload({
      ...payload,
      permissions: {
        ...payload.permissions,
        [entity]: {
          ...payload.permissions[entity],
          [action]: value
        }
      }
    })
  }

  return (
    <ZDialog
      id={'add-role-dialog'}
      isOpen={isOpen}
      title={
        <Box>
          <Typography>Inserisci ruolo</Typography>
          <Input
            fullWidth
            id="input-name"
            variant="standard"
            placeholder={'inserisci nome ruolo'}
            inputProps={{ 'aria-label': 'Inserisci nome ruolo' }}
            onChange={handleNameChanged}
            value={payload.name}
            autoFocus
          />
        </Box>
      }
      content={
        <Table aria-label="role table">
          <TableHead>
            <TableRow key="table-heading">
              <TableCell align="center">{t('common.entity')}</TableCell>
              <TableCell align="center">{t('common.create')}</TableCell>
              <TableCell align="center">{t('common.read')}</TableCell>
              <TableCell align="center">{t('common.update')}</TableCell>
              <TableCell align="center">{t('common.delete')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entities.map((e) => (
              <TableRow
                key={`entity-${e}`}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  height: '5rem'
                }}
              >
                <TableCell align="center">
                  <Typography variant="body">{e}</Typography>
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    key={`${e}-create`}
                    name={`${e}-create`}
                    slotProps={{ input: { 'aria-label': `${e}-create` } }}
                    checked={payload?.permissions?.[e]?.c}
                    onChange={(_, v) => handleChange(e, 'c', v)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    key={`${e}-read`}
                    name={`${e}-read`}
                    slotProps={{ input: { 'aria-label': `${e}-read` } }}
                    checked={payload?.permissions?.[e]?.r}
                    onChange={(_, v) => handleChange(e, 'r', v)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    key={`${e}-update`}
                    name={`${e}-update`}
                    slotProps={{ input: { 'aria-label': `${e}-update` } }}
                    checked={payload?.permissions?.[e]?.u}
                    onChange={(_, v) => handleChange(e, 'u', v)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    key={`${e}-delete`}
                    name={`${e}-delete`}
                    slotProps={{ input: { 'aria-label': `${e}-delete` } }}
                    checked={payload?.permissions?.[e]?.d}
                    onChange={(_, v) => handleChange(e, 'd', v)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      }
      actions={
        <Button
          onClick={() => handleSaveRole()}
          startIcon={< SaveRoundedIcon />}>
          {t('common.save')}
        </Button>
      }
      onClose={handleClose}
    />
  )
}

export default RolesDialog